import { maskEmail } from './maskEmail';

const MAILBOX_SEGMENT = /\/users\/([^/?#]+)/;

const decode = (segment: string): string => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

// Graph routes address the mailbox as /users/{email}/…
export const maskMailboxInUrl = (url: string): string =>
  url.replace(MAILBOX_SEGMENT, (_match, segment: string) => {
    const masked = maskEmail(decode(segment));
    return `/users/${masked ? encodeURIComponent(masked) : '[redacted]'}`;
  });
